

































































import { Component, Prop, Mixins } from "vue-property-decorator";
import UtilMixin from "@/mixins/utilMixin";
import {
  ChikenLinkInfo,
  DEFAULT_CHIKEN_LINK_INFO,
} from "@/model/agreement/chikenLink";

@Component({
  components: {},
})
export default class ChikenLinkInfoViewer extends Mixins(UtilMixin) {
  /** iBow治験連携情報 */
  @Prop({ default: () => DEFAULT_CHIKEN_LINK_INFO })
  chikenLinkInfo!: ChikenLinkInfo;

  @Prop({ default: 0 })
  isChikenUse!: number;

  /** 統一日付フォーマット */
  private DATE_FORMAT = "yyyy年MM月dd日";

  /** 有料版契約期間(表示用) */
  private get paidContractPeriod() {
    // 開始・終了ともに空白の場合は空文字列を返却
    if (
      this.chikenLinkInfo.paid_contract_start == "" &&
      this.chikenLinkInfo.paid_contract_end == ""
    ) {
      return "";
    }

    const startDt = this.newDate(this.chikenLinkInfo.paid_contract_start);
    const endDt = this.newDate(this.chikenLinkInfo.paid_contract_end);

    return `${this.dateToStr(startDt, this.DATE_FORMAT)} 〜 ${this.dateToStr(
      endDt,
      this.DATE_FORMAT
    )}`;
  }
}
